<template>
    <div class="section">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="title mal-text">അപേക്ഷകൾ</div>
                    <div class="value text-primary">{{ responseData.count_total ? responseData.count_total : '00' }}</div>
                </div>
            </div>
        </div>
    </div>

    <div id="search">
        <form class="search-form">
            <label class="label text-primary mal-text" style="margin-bottom:0px;" for="program_filter">പദ്ധതി</label>
            <div class="form-group searchbox mal-text">
                <select
                    class="form-control custom-select"
                    v-model="program_id"
                    id="program_filter"
                    @change="loadReport()"
                >
                    <option value="">എല്ലാ പദ്ധതികളും</option>
                    <option v-for="p in programs" :key="p.id" :value="p.id">{{ p.title }}</option>
                </select>
                <i class="input-icon">
                    <ion-icon name="filter-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>

    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-0">
            <h3 class="text-center mt-0 mal-text custom-title">{{ page_title }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0" v-if="!loading_list && isEmptyList">
        <h4 class="text-center mt-0 mal-text">ഇതുവരെ അപേക്ഷകൾ ഇല്ല</h4>
    </div>

    <div class="section mt-2" v-if="!loading_list && !isEmptyList && user_level < 4">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">പേര്</th>
                            <th scope="col">അപേക്ഷകൾ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in member_lists" :key="row.id === null ? 'no-zone' : row.id">
                            <td class="text-primary font-dark mal-text">
                                <router-link
                                    v-if="row.id !== null"
                                    :to="'/org/' + (user_level + 1) + '/' + row.id + '/sneha-sparsham-report' + programQuery"
                                >
                                    {{ row.name }}
                                </router-link>
                                <span v-else>{{ row.name }}</span>
                            </td>
                            <td class="text-primary font-dark">{{ row.family_count || 0 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="section mt-2" v-if="!loading_list && user_level === 4 && member_lists.length">
        <div v-for="row in member_lists" :key="row.id" class="card mb-2">
            <div class="card-body mal-text">
                <h5 class="mb-1">{{ row.name }}</h5>
                <p class="mb-0 text-muted small">{{ row.program_title }}</p>
                <p class="mb-0 small" v-if="row.contact">ഫോൺ: {{ row.contact }}</p>
                <p class="mb-0 small" v-if="row.created_at">തീയതി: {{ row.created_at }}</p>
            </div>
        </div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "./../layouts/AlertModel.vue";

export default {
    name: "SnehaSparshamReport",
    components: { AlertModel },
    data() {
        return {
            loading_list: false,
            user_level: 1,
            member_lists: [],
            responseData: {},
            page_title: "",
            programs: [],
            program_id: "",
            alert_type: "",
            alert_message: "",
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isEmptyList() {
            if (Array.isArray(this.member_lists)) {
                return this.member_lists.length <= 0;
            }
            return !this.member_lists || (this.member_lists.length !== undefined && this.member_lists.length <= 0);
        },
        programQuery() {
            return this.program_id ? "?program_id=" + this.program_id : "";
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level, 10);
        if (this.$route.query.program_id) {
            this.program_id = this.$route.query.program_id;
        }
        this.$root.updateParent("സ്നേഹ സ്പർശം റിപ്പോർട്ട്");
        this.loadReport();
    },
    methods: {
        loadReport() {
            this.loading_list = true;
            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10),
                program_id: this.program_id || null,
            };
            UserService.authPostRequest("get-sneha-sparsham-report", data).then(
                (response) => {
                    this.loading_list = false;
                    if (response.data.status === "success") {
                        this.responseData = response.data.data;
                        this.member_lists = response.data.data.list || [];
                        this.page_title = response.data.data.page_title || "";
                        this.programs = response.data.data.programs || [];
                    } else {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                () => {
                    this.loading_list = false;
                }
            );
        },
    },
};
</script>
